<template>
  <div class="performance-terms" v-loading="loading">
    <el-form :model="formData" ref="formRef" :show-message="true" label-width="0">
      <!-- 用车规则 -->
      <div class="term-section">
        <div class="term-title" :class="{ 'term-title--collapsible': collapsible }" @click="collapsible && toggleCollapse('useCar')">
          <div class="icon"></div>
          <span>用车规则</span>
          <i v-if="collapsible" :class="collapsed.useCar ? 'el-icon-arrow-right' : 'el-icon-arrow-down'" class="collapse-arrow"></i>
        </div>

        <div class="term-content" v-show="!collapsible || !collapsed.useCar">
          <div class="rules-list">
            <!-- 违章处理 -->
            <ViolationRule
            v-if="formData.rentCarRule.violation"
            :modelValue="formData.rentCarRule.violation"
            @update:modelValue="(val) => formData.rentCarRule.violation = val"
            prop-prefix="rentCarRule.violation"
            :tip="formData.rentCarRuleTip.violationTip"
            :is-mandatory="isMandatory('violation')"
            @remove="removeRule('violation')"
          />

          <!-- 事故出险 -->
          <AccidentRule
            v-if="formData.rentCarRule.insurance"
            :modelValue="formData.rentCarRule.insurance"
            @update:modelValue="(val) => formData.rentCarRule.insurance = val"
            prop-prefix="rentCarRule.insurance"
            :tip="formData.rentCarRuleTip.insuranceTip"
            :is-mandatory="isMandatory('accident')"
            @remove="removeRule('accident')"
          />

          <!-- 行驶区域 -->
          <AreaRule
            id="rule-area"
            v-if="formData.rentCarRule.area"
            :modelValue="formData.rentCarRule.area"
            @update:modelValue="(val) => { formData.rentCarRule.area = val }"
            prop-prefix="rentCarRule.area"
            :tip="formData.rentCarRuleTip.areaTip"
            :is-mandatory="isMandatory('area')"
            @remove="removeRule('area')"
          />

          <!-- 行驶里程 -->
          <MileageRule
            id="rule-mileage"
            v-if="formData.rentCarRule.distance"
            :modelValue="formData.rentCarRule.distance"
            @update:modelValue="(val) => { formData.rentCarRule.distance = val }"
            prop-prefix="rentCarRule.distance"
            :tip="formData.rentCarRuleTip.distanceTip"
            :is-mandatory="isMandatory('mileage')"
            @remove="removeRule('mileage')"
          />

          <!-- 车辆维修 -->
          <MaintenanceRule
            id="rule-maintenance"
            v-if="formData.rentCarRule.maintenanceFix"
            :modelValue="formData.rentCarRule.maintenanceFix"
            @update:modelValue="(val) => { formData.rentCarRule.maintenanceFix = val }"
            prop-prefix="rentCarRule.maintenanceFix"
            :tip="formData.rentCarRuleTip.maintenanceFixTip"
            @remove="removeRule('maintenance')"
          />

          <!-- 车辆保养 -->
          <ServiceRule
            id="rule-service"
            v-if="formData.rentCarRule.maintenanceMain"
            :modelValue="formData.rentCarRule.maintenanceMain"
            @update:modelValue="(val) => { formData.rentCarRule.maintenanceMain = val }"
            prop-prefix="rentCarRule.maintenanceMain"
            :tip="formData.rentCarRuleTip.maintenanceMainTip"
            @remove="removeRule('service')"
          />

          <!-- GPS损坏 -->
          <GpsRule
            id="rule-gps"
            v-if="formData.rentCarRule.gps"
            :modelValue="formData.rentCarRule.gps"
            @update:modelValue="(val) => { formData.rentCarRule.gps = val }"
            prop-prefix="rentCarRule.gps"
            :tip="formData.rentCarRuleTip.gpsTip"
            @remove="removeRule('gps')"
          />

          <!-- 证件丢失补办 -->
          <DocumentRule
            id="rule-document"
            v-if="formData.rentCarRule.licence"
            :licence="formData.rentCarRule.licence"
            @update:licence="(val) => { formData.rentCarRule.licence = val }"
            :licenceChecked="formData.rentCarRule.licenceChecked"
            @update:licenceChecked="(val) => { formData.rentCarRule.licenceChecked = val }"
            prop-prefix="rentCarRule"
            :tip="formData.rentCarRuleTip.licenceTip"
            @remove="removeRule('document')"
          />

          </div>
          <!-- 新增按钮 -->
          <div class="add-btn-wrapper">
            <el-dropdown @command="addRule" trigger="click" style="width: 100%">
              <el-button icon="el-icon-plus" class="add-btn" :disabled="isAllRulesAdded">新增用车规则</el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  v-for="(label, key) in ruleLabels"
                  :key="key"
                  :command="key"
                  :disabled="isRuleDisabled(key)">
                  {{ label }}
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </div>

      <!-- 还车说明 -->
      <div class="term-section">
        <div class="term-title" :class="{ 'term-title--collapsible': collapsible }" @click="collapsible && toggleCollapse('returnCar')">
          <div class="icon"></div>
          <span>还车说明</span>
          <i v-if="collapsible" :class="collapsed.returnCar ? 'el-icon-arrow-right' : 'el-icon-arrow-down'" class="collapse-arrow"></i>
        </div>

        <div class="term-content" v-show="!collapsible || !collapsed.returnCar">
          <div class="rules-list" style="margin-bottom: 35px;">
            <!-- 押金退还时间 -->
            <DepositReturnRule
            v-if="formData.returnCarRule.depositRefund && props.rentDataInfo.rentCategory === CATEGORY_CODE_MAP.ZU_CHE"
            :modelValue="formData.returnCarRule.depositRefund"
            @update:modelValue="(val) => formData.returnCarRule.depositRefund = val"
            prop-prefix="returnCarRule.depositRefund"
            :tip="formData.returnCarRuleTip.depositRefundTip"
            :is-mandatory="isMandatory('depositReturn')"
            @remove="removeRule('depositReturn')"
          />

          <!-- 提前还车 -->
          <EarlyReturnRule
            v-if="formData.returnCarRule.returnEarly"
            :modelValue="formData.returnCarRule.returnEarly"
            @update:modelValue="(val) => formData.returnCarRule.returnEarly = val"
            prop-prefix="returnCarRule.returnEarly"
            :tip="formData.returnCarRuleTip.returnEarlyTip"
            :is-mandatory="isMandatory('earlyReturn')"
            @remove="removeRule('earlyReturn')"
          />

          <!-- 还车电量要求 -->
          <ReturnBatteryRule
            id="rule-returnBattery"
            v-if="formData.returnCarRule.returnBattery"
            :modelValue="formData.returnCarRule.returnBattery"
            @update:modelValue="(val) => { formData.returnCarRule.returnBattery = val }"
            prop-prefix="returnCarRule.returnBattery"
            :tip="formData.returnCarRuleTip.returnBatteryTip"
            @remove="removeRule('returnBattery')"
          />

          </div>
          <!-- 新增按钮 -->
          <div class="add-btn-wrapper">
            <el-dropdown @command="addRule" trigger="click" style="width: 100%">
              <el-button icon="el-icon-plus" class="add-btn" :disabled="isAllReturnRulesAdded">新增还车说明</el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  v-for="(label, key) in returnRuleLabels"
                  :key="key"
                  :command="key"
                  :disabled="isReturnRuleDisabled(key)">
                  {{ label }}
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>

        </div>
      </div>
    </el-form>
  </div>
</template>

<script setup>
import { reactive, computed, ref, nextTick } from 'vue'
import { cloneDeep, pickBy, isNil } from 'lodash'
import { CATEGORY_CODE_MAP } from '@/store/dict/rentPlanDict.js'


import ViolationRule from './rules/ViolationRule.vue'
import AccidentRule from './rules/AccidentRule.vue'
import AreaRule from './rules/AreaRule.vue'
import MileageRule from './rules/MileageRule.vue'
import MaintenanceRule from './rules/MaintenanceRule.vue'
import ServiceRule from './rules/ServiceRule.vue'
import GpsRule from './rules/GpsRule.vue'
import DocumentRule from './rules/DocumentRule.vue'
import DepositReturnRule from './rules/DepositReturnRule.vue'
import EarlyReturnRule from './rules/EarlyReturnRule.vue'
import ReturnBatteryRule from './rules/ReturnBatteryRule.vue'

const props = defineProps({
  loading: {
    type: Boolean,
    default: false,
  },
  rentDataInfo: {
    type: Object,
    default: () => ({}),
  },
  collapsible: {
    type: Boolean,
    default: false,
  },
})

const assignNotNull = (target, src) => {
  if (!src || typeof src !== 'object') return
  const valid = pickBy(src, (value) => !isNil(value) && value !== 'null' && value !== '')
  if (Object.keys(valid).length) Object.assign(target, valid)
}

const formRef = ref(null)

// 折叠状态
const collapsed = reactive({
  useCar: false,
  returnCar: false,
})

const toggleCollapse = (key) => {
  collapsed[key] = !collapsed[key]
}

// 校验通过则折叠，校验不通过则展开（复用表单自身的校验规则）
const autoCollapseFilledSections = async () => {
  if (!props.collapsible || !formRef.value) return
  await nextTick()

  try {
    await formRef.value.validate()
    collapsed.useCar = true
    collapsed.returnCar = true
  } catch {
    collapsed.useCar = false
    collapsed.returnCar = false
  }
}


// 定义必填项，不可删除
const mandatoryFields = ['violation', 'accident', 'depositReturn', 'earlyReturn']

const ruleLabels = {
  area: '行驶区域',
  mileage: '行驶里程',
  maintenance: '车辆维修',
  service: '车辆保养',
  gps: 'GPS损坏',
  document: '证件丢失补办',
}

const returnRuleLabels = {
  returnBattery: '还车电量要求',
}

// 默认值配置
const defaultValues = {
  violation: {
    pointFeePerScore: '',
    overdueFeeWithDeduction: '',
    overdueFeeWithoutDeduction: '',
  },
  insurance: {
    strongRisk: '',
    thirdParty: '',
    carDamage: '',
    carLost: '',
    people: '',
    nonDeductible: '',
    accidentLiabilityFullFee: '',
    vehicleDepreciationFullPercent: '',
    accidentLiabilityMajorFee: '',
    vehicleDepreciationMajorPercent: '',
    accidentLiabilitySecondaryFee: '',
    vehicleDepreciationSecondaryPercent: '',
    accidentLiabilitySharedFee: '',
    vehicleDepreciationSharedPercent: '',
    accidentLiabilityNoFee: '',
    vehicleDepreciationNoPercent: '',
    hasCommercialInsurance: false,
  },
  area: {
    limit: '',
    limitArea: '',
    fee: '',
  },
  distance: {
    limit: '',
    limitDistance: '',
    fee: '',
  },
  maintenanceFix: {
    otherFixFee: '',
  },
  maintenanceMain: {
    maintenanceInterval: '',
    maintenanceOverdueFee: '',
  },
  gps: {
    gpsDamageFee: '',
  },
  licence: {
    drivingLicenseReissueFee: '',
    vehicleRegistrationReissueFee: '',
    vehicleKeyReissueFee: '',
    vehiclePlateReissueFee: '',
  },
  licenceChecked: {
    drivingLicenseReissueFee: false,
    vehicleRegistrationReissueFee: false,
    vehicleKeyReissueFee: false,
    vehiclePlateReissueFee: false,
  },
  returnEarly: {
    returnCarDeliveryFeeType: '',
    returnCarDeliveryFee: '',
    returnCarDeliveryFeePercent: '',
  },
  depositRefund: {
    depositRefundDays: '',
  },
  returnBattery: {
    returnBatteryRemaining: '',
    returnBatteryRemainingUnit: 'km',
    batteryRechargeFee: '',
  },
}

const formData = reactive({
  // 用车规则AI提示信息
  rentCarRuleTip: {
    violationTip: '', // 违章处理
    insuranceTip: '', // 事故出险
    areaTip: '', // 行驶区域
    distanceTip: '', // 行驶里程
    maintenanceFixTip: '', // 车辆维修
    maintenanceMainTip: '', // 车辆保养
    gpsTip: '', // GPS损坏
    licenceTip: '', // 证件挂失补办
  },
  // 还车说明AI提示信息
  returnCarRuleTip: {
    depositRefundTip: '', // 押金退还时间
    returnEarlyTip: '', // 提前退车
    returnBatteryTip: '', // 还车电量要求
  },
  rentCarRule: {
    violation: cloneDeep(defaultValues.violation),
    insurance: cloneDeep(defaultValues.insurance),
    area: null,
    distance: null,
    maintenanceFix: null,
    maintenanceMain: null,
    gps: null,
    licence: null,
    licenceChecked: null,
  },
  returnCarRule: {
    returnEarly: cloneDeep(defaultValues.returnEarly),
    depositRefund: cloneDeep(defaultValues.depositRefund),
    returnBattery: null,
  },
})

const isRuleDisabled = (key) => {
  if (key === 'area') return !!formData.rentCarRule.area
  if (key === 'mileage') return !!formData.rentCarRule.distance
  if (key === 'maintenance') return !!formData.rentCarRule.maintenanceFix
  if (key === 'service') return !!formData.rentCarRule.maintenanceMain
  if (key === 'gps') return !!formData.rentCarRule.gps
  if (key === 'document') return !!formData.rentCarRule.licence
  return false
}

const isAllRulesAdded = computed(() => {
  return Object.keys(ruleLabels).every((key) => isRuleDisabled(key))
})

const isReturnRuleDisabled = (key) => {
  if (key === 'returnBattery') return !!formData.returnCarRule.returnBattery
  return false
}

const isAllReturnRulesAdded = computed(() => {
  return Object.keys(returnRuleLabels).every((key) => isReturnRuleDisabled(key))
})

const isMandatory = (key) => mandatoryFields.includes(key)

const removeRule = (key) => {
  if (isMandatory(key)) return

  // 清空对应的数据
  if (key === 'area') {
    formData.rentCarRule.area = null
    formData.rentCarRuleTip.areaTip = ''
  } else if (key === 'mileage') {
    formData.rentCarRule.distance = null
    formData.rentCarRuleTip.distanceTip = ''
  } else if (key === 'maintenance') {
    formData.rentCarRule.maintenanceFix = null
    formData.rentCarRuleTip.maintenanceFixTip = ''
  } else if (key === 'service') {
    formData.rentCarRule.maintenanceMain = null
    formData.rentCarRuleTip.maintenanceMainTip = ''
  } else if (key === 'gps') {
    formData.rentCarRule.gps = null
    formData.rentCarRuleTip.gpsTip = ''
  } else if (key === 'document') {
    formData.rentCarRule.licence = null
    formData.rentCarRule.licenceChecked = null
    formData.rentCarRuleTip.licenceTip = ''
  } else if (key === 'returnBattery') {
    formData.returnCarRule.returnBattery = null
    formData.returnCarRuleTip.returnBatteryTip = ''
  }
}

const addRule = (key) => {
  if (key === 'area') {
    formData.rentCarRule.area = cloneDeep(defaultValues.area)
  } else if (key === 'mileage') {
    formData.rentCarRule.distance = cloneDeep(defaultValues.distance)
  } else if (key === 'maintenance') {
    formData.rentCarRule.maintenanceFix = cloneDeep(defaultValues.maintenanceFix)
  } else if (key === 'service') {
    formData.rentCarRule.maintenanceMain = cloneDeep(defaultValues.maintenanceMain)
  } else if (key === 'gps') {
    formData.rentCarRule.gps = cloneDeep(defaultValues.gps)
  } else if (key === 'document') {
    formData.rentCarRule.licence = cloneDeep(defaultValues.licence)
    formData.rentCarRule.licenceChecked = cloneDeep(defaultValues.licenceChecked)
  } else if (key === 'returnBattery') {
    formData.returnCarRule.returnBattery = cloneDeep(defaultValues.returnBattery)
  }

  nextTick(() => {
    const el = document.querySelector(`#rule-${key}`)
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'nearest' })
    }
  })
}

const resetFormData = () => {
  // Reset rentCarRuleTip
  Object.keys(formData.rentCarRuleTip).forEach((key) => {
    formData.rentCarRuleTip[key] = ''
  })

  // Reset returnCarRuleTip
  Object.keys(formData.returnCarRuleTip).forEach((key) => {
    formData.returnCarRuleTip[key] = ''
  })

  // Reset rentCarRule
  formData.rentCarRule.violation = cloneDeep(defaultValues.violation)
  formData.rentCarRule.insurance = cloneDeep(defaultValues.insurance)
  formData.rentCarRule.area = null
  formData.rentCarRule.distance = null
  formData.rentCarRule.maintenanceFix = null
  formData.rentCarRule.maintenanceMain = null
  formData.rentCarRule.gps = null
  formData.rentCarRule.licence = null
  formData.rentCarRule.licenceChecked = null

  // Reset returnCarRule
  formData.returnCarRule.returnEarly = cloneDeep(defaultValues.returnEarly)
  formData.returnCarRule.depositRefund = cloneDeep(defaultValues.depositRefund)
  formData.returnCarRule.returnBattery = null

  nextTick(() => {
    formRef.value?.clearValidate()
  })
}

const setFormData = (data) => {
  resetFormData()
  if (!data) return

  if (data.rentCarRuleTip) {
    assignNotNull(formData.rentCarRuleTip, data.rentCarRuleTip)
  }
  if (data.returnCarRuleTip) {
    assignNotNull(formData.returnCarRuleTip, data.returnCarRuleTip)
  }

  if (data.rentCarRule) {
    const rc = data.rentCarRule
    if (rc.violation) assignNotNull(formData.rentCarRule.violation, rc.violation)
    if (rc.insurance) {
      assignNotNull(formData.rentCarRule.insurance, rc.insurance)
      if (rc.insurance.thirdParty || rc.insurance.carDamage || rc.insurance.carLost || rc.insurance.people || rc.insurance.nonDeductible) {
        formData.rentCarRule.insurance.hasCommercialInsurance = true
      }
    }
    if (rc.area) {
      formData.rentCarRule.area = cloneDeep(defaultValues.area)
      assignNotNull(formData.rentCarRule.area, rc.area)
    }
    if (rc.distance) {
      formData.rentCarRule.distance = cloneDeep(defaultValues.distance)
      assignNotNull(formData.rentCarRule.distance, rc.distance)
      // 特殊处理 limit 为 0 的情况，因为 assignNotNull 会过滤掉 0
      if (rc.distance.limit === 0 || rc.distance.limit === '0') {
        formData.rentCarRule.distance.limit = 0
      }
    }
    if (rc.maintenanceFix) {
      formData.rentCarRule.maintenanceFix = cloneDeep(defaultValues.maintenanceFix)
      assignNotNull(formData.rentCarRule.maintenanceFix, rc.maintenanceFix)
    }
    if (rc.maintenanceMain) {
      formData.rentCarRule.maintenanceMain = cloneDeep(defaultValues.maintenanceMain)
      assignNotNull(formData.rentCarRule.maintenanceMain, rc.maintenanceMain)
    }
    if (rc.gps) {
      formData.rentCarRule.gps = cloneDeep(defaultValues.gps)
      assignNotNull(formData.rentCarRule.gps, rc.gps)
    }
    if (rc.licence) {
      formData.rentCarRule.licence = cloneDeep(defaultValues.licence)
      formData.rentCarRule.licenceChecked = cloneDeep(defaultValues.licenceChecked)
      assignNotNull(formData.rentCarRule.licence, rc.licence)
      for (const key in rc.licence) {
        if (rc.licence[key]) {
          formData.rentCarRule.licenceChecked[key] = true
        }
      }
    }
  }

  if (data.returnCarRule) {
    const rcr = data.returnCarRule
    if (rcr.returnEarly) assignNotNull(formData.returnCarRule.returnEarly, rcr.returnEarly)
    if (rcr.depositRefund) assignNotNull(formData.returnCarRule.depositRefund, rcr.depositRefund)
    if (rcr.returnBattery) {
      formData.returnCarRule.returnBattery = cloneDeep(defaultValues.returnBattery)
      assignNotNull(formData.returnCarRule.returnBattery, rcr.returnBattery)
    }
  }

  // 数据填充后自动检测并折叠已完成的模块
  nextTick(() => {
    autoCollapseFilledSections()
  })
}

const validateForm = async () => {
  if (!formRef.value) return false
  try {
    await formRef.value.validate()
    const result = cloneDeep(formData)

    // Check mandatory rules that might have been disabled via rentDataInfo or other logic?
    // DepositReturnRule logic:
    if (props.rentDataInfo.rentCategory !== CATEGORY_CODE_MAP.ZU_CHE) {
      result.returnCarRule.depositRefund = null
    }

    return result
  } catch (e) {
    if (props.collapsible) {
      collapsed.useCar = false
      collapsed.returnCar = false
    }
    nextTick(() => {
      const errorElement = formRef.value?.$el?.querySelector('.el-form-item.is-error')
      if (errorElement) {
        errorElement.scrollIntoView({ behavior: 'smooth', block: 'center' })
      }
    })
    return false
  }
}

defineExpose({
  setFormData,
  validateForm,
})
</script>

<style lang="scss" scoped>
.performance-terms {
  .term-section {
    margin-bottom: 36px;

    .rules-list {
      margin-bottom: 40px;
    }

    .term-title {
      font-family: PingFang SC;
      font-size: 14px;
      font-weight: 500;
      color: #2A6BFF;
      display: flex;
      align-items: center;
      margin-bottom: 16px;

      &--collapsible {
        cursor: pointer;
        user-select: none;
      }

      .icon {
        width: 3px;
        height: 14px;
        background: #2A6BFF;
        margin-right: 8px;
      }

      .collapse-arrow {
        margin-left: 8px;
        font-size: 12px;
        color: #2A6BFF;
        transition: transform 0.2s;
      }
    }
  }
}
::v-deep .input-number-tip {
  display: none;
}
</style>
